import { render } from "./GameJigsawPuzzleBlock.vue?vue&type=template&id=2ec32a36&scoped=true"
import script from "./GameJigsawPuzzleBlock.vue?vue&type=script&lang=js"
export * from "./GameJigsawPuzzleBlock.vue?vue&type=script&lang=js"

import "./GameJigsawPuzzleBlock.vue?vue&type=style&index=0&id=2ec32a36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec32a36"],['__file',"src/vue/components/GameJigsawPuzzleBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ec32a36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ec32a36', __exports__)) {
    api.reload('2ec32a36', __exports__)
  }
  
  module.hot.accept("./GameJigsawPuzzleBlock.vue?vue&type=template&id=2ec32a36&scoped=true", () => {
    api.rerender('2ec32a36', render)
  })

}


export default __exports__